import React from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import PropTypes from 'prop-types';
import '../../../assets/scss/emoji.scss';
import { useTheme } from '../../../contexts/ThemeContext';

export const Emoji = (props = {}) => {
    const { onEmojiClick, emojiState = true, handleCloseEmojiClick = () => {} } = props;
    const { theme } = useTheme();

    const handleOnKeyPress = React.useCallback(
        event => {
            if (event.key === 'Escape') {
                handleCloseEmojiClick();
            }
        },
        [handleCloseEmojiClick],
    );

    React.useEffect(() => {
        if (!emojiState) return;
        document.addEventListener('keydown', handleOnKeyPress, false);
        return () => document.removeEventListener('keydown', handleOnKeyPress, false);
    }, [emojiState, handleOnKeyPress]);

    /**
     * addEmoji() method to pass emojis to parent.
     */
    const addEmoji = (e = {}) => {
        let emoji = e.native;
        onEmojiClick(emoji);
    };

    return (
        emojiState && (
            <span className="emojiPicker-container">
                {/* Without this the picker defaults to "auto", which follows the
                    operating system instead of the theme the user picked in the app. */}
                <Picker
                    className="emoji_picker"
                    style={{ width: '100%' }}
                    dynamicWidth={true}
                    data={data}
                    theme={theme}
                    previewEmoji={false}
                    enableFrequentEmojiSort={false}
                    onEmojiSelect={addEmoji}
                />
            </span>
        )
    );
};

Emoji.propTypes = {
    onEmojiClick: PropTypes.func,
    emojiState: PropTypes.bool,
    handleCloseEmojiClick: PropTypes.func,
};
